import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CodedResponseModel } from "src/app/model/CodedResponseModel";
import { CertificationForm } from "src/app/model/responsible/CertificationForm";
import { SectionBundle } from "src/app/model/responsible/FormSectionBundle";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class CertificationFormAPI {
    constructor(
        private http: HttpClient,
    ) {}

    /** List all certification forms */
    public index() {
        return this.http.get<CodedResponseModel>(`${environment.apiUrl}certification-forms`);
    }

    /** Get published sections for a certification form */
    public get(id: number) {
        return this.http.get<CodedResponseModel>(`${environment.apiUrl}certification-forms/${id}`);
    }

    /** Get draft sections for a certification form */
    public getDraft(id: number) {
        return this.http.get<CodedResponseModel>(`${environment.apiUrl}certification-forms/${id}/draft`);
    }

    /** Create a new certification form */
    public create(form: CertificationForm) {
        return this.http.post<CodedResponseModel>(
            `${environment.apiUrl}certification-forms`,
            form.responsify()
        );
    }

    /** Update a certification form's metadata */
    public update(form: CertificationForm) {
        return this.http.put<CodedResponseModel>(
            `${environment.apiUrl}certification-forms/${form.id}`,
            form.responsify()
        );
    }

    /** Autosave draft sections for a certification form */
    public saveDraft(id: number, data: SectionBundle) {
        return this.http.put<CodedResponseModel>(
            `${environment.apiUrl}certification-forms/${id}/draft`,
            { sections: data.responsify() }
        );
    }

    /** Publish the draft for a certification form */
    public publishDraft(id: number, data: SectionBundle, extras: any) {
        return this.http.put<CodedResponseModel>(
            `${environment.apiUrl}certification-forms/${id}/publish`,
            { sections: data.responsify(), extra: extras }
        );
    }

    /** Acquire or refresh an edit lock for a certification form */
    public tryLock(id: number, lock?: string) {
        return this.http.post<CodedResponseModel>(
            `${environment.apiUrl}certification-forms/${id}/lock`,
            lock
        );
    }
}
